function dateHourSec(h) {
    let d = new Date();
    d.setHours(h, 0, 0, 0);
    let sec = d.getTime();
    return parseInt(sec / 1000);
}
function numberadd0(v, len) {
    return ('000000' + v).slice(-len);
}
function dateformat(d, ff) {
    let yyyy = d.getFullYear();
    let MM = numberadd0(d.getMonth() + 1, 2);
    let dd = numberadd0(d.getDate(), 2);
    let HH = numberadd0(d.getHours(), 2);
    let mm = numberadd0(d.getMinutes(), 2);
    let ss = numberadd0(d.getSeconds(), 2);
    return ff.replace(/yyyy/g, yyyy)
        .replace(/MM/g, MM)
        .replace(/dd/g, dd)
        .replace(/HH/g, HH)
        .replace(/mm/g, mm)
        .replace(/ss/g, ss);
}
function fileCompress(file, maxsize, callback) {
    let fileType = file.type;
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function() {
        let image = new Image()
        image.src = this.result;
        image.onload = function() {
            let scale = 1;
            let canvas = document.createElement('canvas')
            if (this.width > maxsize || this.height > maxsize) {
                if (this.width > this.height) {
                    scale = maxsize / this.width;
                } else {
                    scale = maxsize / this.height;
                }
            }
            //
            let imgWidth = scale * this.width;
            let imgHeight = scale * this.height;
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            console.log(imgWidth, imgHeight)
            let ctx = canvas.getContext('2d');
            ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
            //
            let imgdata = canvas.toDataURL(fileType, 0.7);
            let data = imgdata.split(',', 2)[1];
            callback(data);
            // that.uploadImage(data, name);
        }
    }
}
function layuiDateTo(date) {
    let dd = new Date(`${date.year}/${date.month}/${date.date} ${date.hours}:${date.minutes}:${date.seconds}`);
    return dd;
}
function secsformat(secs) {
    if (secs <= 0) {
        return '00:00';
    }
    let val1 = numberadd0(parseInt(secs / 60), 2);
    let val2 = numberadd0(parseInt(secs % 60), 2);
    return `${val1}:${val2}`;
}
function rem2px(val) {
    if (!window.pxbase) {
        let hfs = parseFloat(document.documentElement.style.fontSize.replace('px', ''));
        window.pxbase = 75 / hfs;
    }
    return val / window.pxbase;
}
function vmiddle(el) {
    let p = el;
    let winHeight = window.innerHeight;
    let div1Height = p.offsetHeight;
    let top = (winHeight - div1Height) / window.pxbase;
    console.log(el, winHeight, div1Height, top);
    el.style.top = top + 'px';
}
function isWeixin() {
    let ua = window.navigator.userAgent.toLowerCase();
    return /micromessenger/.test(ua);
}
function randomStr(length) {
    let letters = "0123456789abcdefghijklmnopqrstuvwxyz";
    let buffer = [];

    for (let i = 0; i < length; i++) {
        let index = parseInt(Math.random() * letters.length);
        buffer.push(letters[index]);
    }
    return buffer.join('');
}
function letterize(number) {
    let letters = "0123456789abcdefghijklmnopqrstuvwxyz";
    let abcsLen = letters.length;

    let buffer = [];
    do {
        let a = parseInt(number / abcsLen);
        let b = number % abcsLen;
        buffer.push(letters[b]);
        number = a;
    } while (number > 0);
    buffer.reverse();
    return buffer.join('');
}
function createIdcode() {
    let num = new Date().getTime();
    return letterize(num) + randomStr(2);
}
function randomNums(num, maxLength) {
    let arr = [];
    while (arr.length < num) {
        let r = parseInt(Math.random() * maxLength);
        if (arr.indexOf(r) < 0) {
            arr.push(r);
        }
    }
    return arr;
}
function randomArr(arr, num) {
    let varr = [];
    let narr = randomNums(num, arr.length);
    for (let i=0; i<num; i++) {
        let r = narr[i];
        let val = arr[r];
        varr.push(val);
    }
    console.log(narr, varr);
    return varr;
}
export default {
    dateHourSec,
    numberadd0,
    dateformat,
    fileCompress,
    layuiDateTo,
    secsformat,
    rem2px,
    vmiddle,
    isWeixin,
    randomStr,
    letterize,
    createIdcode,
    randomNums,
    randomArr,
}